<script>
export default Vue.extend({
  data() {
    return {
      active: false,
      creating: true,
      model: {}
    };
  },
  methods: {
    open(model) {
      this.show();
    },
    close() {
      this.hide();
    },
    show() {
      this.active = true;
    },
    hide() {
      this.active = false;
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/modals/BaseModal.vue